
'use client';

import React from "react";

export function MapView() {
    // A real implementation would use a Maps SDK and API key from .env
    const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.73583168105!2d55.307034176189696!3d25.24582107767973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43001c79eee1%3A0xd5949103024d1444!2sKARAMA%20BUSINESS%20CENTER!5e0!3m2!1sen!2sae!4v1757313067763!5m2!1sen!2sae";

    return (
        <iframe
            src={mapSrc}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={false}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Service Area Map"
        ></iframe>
    );
}
